import styled from 'styled-components';
import React from 'react';
import PropTypes from 'prop-types';
import { sanitize } from 'dompurify';
import MessageBox from '../MessageBox';

export const MessageBoxStyles = styled(MessageBox)`
    max-width: 700px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
`;

const ErrorMessage = ({ error, copy }) => {
    if (!error || !error.message) return null;
    console.error(error.message);
    return (
        <MessageBoxStyles type="fatal">
            {/* eslint-disable-next-line react/no-danger */}
            {copy && <div dangerouslySetInnerHTML={{ __html: sanitize(copy) }} />}
        </MessageBoxStyles>
    );
};

ErrorMessage.defaultProps = {
    error: {},
};

ErrorMessage.propTypes = {
    error: PropTypes.object,
    copy: PropTypes.string,
};

export default ErrorMessage;
